<template>
	<div class="recharge-page ">
		<div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('assestLog.label2') }}	<div class="bind flex-center" @click="toBind">
				<img :src="addressUrl" alt="">
				{{ $t('bang-ding-di-zhi') }}	</div>
    </div>

		<div class="recharge-main">
			<div class="title">{{ $t('ti-bi-bi-zhong') }}</div>
			<div class="sub-title">{{ $t('qing-dian-ji-xia-fang-xu-yao-ti-bi-wang-luo-de-bi-zhong') }}</div>
			
			<!-- 没有绑定地址时的提示 -->
			<div v-if="!hasBindedAddress" class="no-address-tip">
				<div class="tip-content">
					<img :src="addressUrl" alt="">
					<p>{{ $t('mei-you-bang-ding-ti-bi-di-zhi') }}</p>
					<div class="tip-btn" @click="toBind">
						{{ $t('qu-bang-ding-di-zhi') }}
					</div>
				</div>
			</div>
			
			<!-- 已绑定地址列表 -->
			<div v-else class="recharge-list">
				<div class="list" v-for="(item, i) in filteredWithdrawList" :key="i" :class="[i < 2 ? 'big' : '', withdrawInfo.key == item.key ? 'active' : '']" @click="chooseBit(item)">
					<div class="name">
						<img :src="item.icon" alt="">
						<span>{{item.name}}</span>
					</div>
				</div>
			</div>

		</div>

		<div class="page-form  mt-20"  v-show="withdrawInfo.key && hasBindedAddress">
			<div class="form-item">
				<div class="label">{{ $t('withdraw.label2') }}</div>
				<div class="input">
					<input type="text" v-model="withdrawInfo.address" readonly>
				</div>
			</div>

			<div class="form-item">
				<div class="label">{{ $t('withdraw.label4') }}</div>
				<div class="input flex-center-between">
					<input type="text"   v-model="form.money" :placeholder="$t('withdraw.labelPlaceholder4')">
					<div class="flex-center adot long">
						<span @click="setAll">{{ $t('withdraw.label6') }}</span>
					</div>
				</div>
				<div class="flex-center-start desc-line">
					<div>{{ $t('withdraw.label5') }}：</div>
					<div class="count">{{parseFloat(userMoney).toFixed(4)}} </div>
				</div>
			</div>


			<div class="btn ">
				<Button   @click="submit">{{ $t('withdraw.btn2') }}</Button>
			</div>
		</div>

		<div class="space-line"></div>
		
		
		<div class="page-title">{{ $t('quan-bu-ti-bi-ji-lu') }}</div>

		<div class="list-table clear-bg">
      <div class="th-line flex-center-between">
        <div class="th flex-2">{{ $t('ti-bi-bi-zhong-0') }}</div>
        <div class="th flex-2">{{ $t('chart_page.time') }}</div>
        <div class="th flex-2">{{ $t('withdraw.label2') }}</div>
        <div class="th flex-2">{{ $t('withdraw.label4') }}</div>
        <div class="th action">{{ $t('finance.label12') }}</div>
      </div>
      <div class="tbody">
        <div class="td-line flex-center-between" v-for="(item, i) in logList" :key="i" >
          <div class="td flex-2 flex-center-start">
            <img :src="'/upload/' + item.Currency.Logo" alt="">
            <span>{{item.Currency.ShortName}}</span>
          </div>
          <div class="td flex-2">{{item.CreatedAt}}</div>
          <div class="td flex-2">{{item.Address}}</div>
          <div class="td flex-2">{{parseFloat(item.Price).toFixed(4)}}</div>
          <div class="td action flex-center">
            <span class="point"
                  :class="item.Status == 2 ? 'red' : (item.Status == 0 ? 'yellow' : 'green')"></span>
            {{ $t(`withdraw.status${item.Status}`) }}
          </div>
        </div>
      </div>
    </div>

    <pageBar :total="page.total" @changePage="changePage"></pageBar>

		<div class="page-modal address" v-show="showModal">
      <div class="title flex-center-between">
        <span>{{ $t('bang-ding-di-zhi-0') }}</span>
        <img :src="closeUrl" alt="" @click="cancel">
      </div>
      <div class="content">
				 <div class="page-form mini">
					<div class="form-item">
						<div class="label flex-center-start">
							<img :src="bitUrl1" alt="">USDT-TRC20
						</div>
						<div class="input">
							<input type="text" v-model="addressForm['USDT-TRC20']" :placeholder="$t('qing-shu-ru-xu-yao-bang-ding-de-di-zhi')">
						</div>
					</div>
					<div class="form-item">
						<div class="label flex-center-start">
							<img :src="bitUrl1" alt="">USDT-ERC20
						</div>
						<div class="input">
							<input type="text" v-model="addressForm['USDT-ERC20']" :placeholder="$t('qing-shu-ru-xu-yao-bang-ding-de-di-zhi-0')">
						</div>
					</div>
					<div class="form-item">
						<div class="label flex-center-start">
							<img :src="bitUrl2" alt="">USDC-TRC20
						</div>
						<div class="input">
							<input type="text" v-model="addressForm['USDC-TRC20']" :placeholder="$t('qing-shu-ru-xu-yao-bang-ding-de-di-zhi-1')">
						</div>
					</div>
					<div class="form-item">
						<div class="label flex-center-start">
							<img :src="bitUrl2" alt="">USDC-ERC20
						</div>
						<div class="input">
							<input type="text" v-model="addressForm['USDC-ERC20']" :placeholder="$t('qing-shu-ru-xu-yao-bang-ding-de-di-zhi-2')">
						</div>
					</div>
					<div class="form-item">
						<div class="label flex-center-start">
							<img :src="bitUrl3" alt="">ETH-ERC20
						</div>
						<div class="input">
							<input type="text" v-model="addressForm['ETH-ERC20']" :placeholder="$t('qing-shu-ru-xu-yao-bang-ding-de-di-zhi-3')">
						</div>
					</div>
					<div class="form-item">
						<div class="label flex-center-start">
							<img :src="bitUrl4" alt="">BTC
						</div>
						<div class="input">
							<input type="text" v-model="addressForm['BTC']" :placeholder="$t('qing-shu-ru-xu-yao-bang-ding-de-di-zhi-4')">
						</div>
					</div>

					<div class="btn">
						<Button @click="submitAddress">{{ $t('addAddress.btn1') }}</Button>
					</div>
				</div>
      </div>

    </div>
	</div>
</template>
<script>
import { Popup, Button, Icon} from 'vant'
import { debtType, withdrawLists } from '@/api/assest'
import { withdraw, wallet } from '@/api/assest'
import { addressList } from '@/api/setting'
import {formatNumber} from '@/utils/common'
import pageBar from '@/components/pageBar'
export default {
	components: {
    Popup,
    Button,
		Icon,
		pageBar
  },
  data() {
		return {
			form: {
				address: '',
				money: '',
			},
			addressForm: {
        'USDT-TRC20': '',
        'USDT-ERC20': '',
        'USDC-TRC20': '',
        'USDC-ERC20': '',
        'ETH-ERC20': '',
        'BTC': '',
      },
			inputActive: false,
			userMoney: 0,
			backUrl: require('../../assets/imgs/icon-back.png'),
			closeUrl: require('../../assets/imgs/icon-close.png'),
			addressUrl: require('../../assets/imgs/icon-address.png'),
			bitUrl1:  require('../../assets/imgs/bit1.png'),
      bitUrl2:  require('../../assets/imgs/bit2.png'),
      bitUrl3:  require('../../assets/imgs/bit3.png'),
      bitUrl4:  require('../../assets/imgs/bit4.png'),
			showRecharge: false,
      rechargeIndex: 0,
			withdrawInfo: {
				ID: '',
				Address: ''
			},
			withdrawAddressList: [
				{
					icon: require('../../assets/imgs/bit4.png'),
					name: 'BTC',
					key: 'BTC',
				},
				{
					icon: require('../../assets/imgs/bit3.png'),
					name: 'ETH',
					key: 'ETH-ERC20',
				},
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDT-TRC20',
					key: 'USDT-TRC20'
				},
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDT-ERC20',
					key: 'USDT-ERC20'
				},
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDC-TRC20',
					key: 'USDC-TRC20'
				},
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDC-ERC20',
					key: 'USDC-ERC20'
				},
			],
			addressArr: [],
			page: {
				page: 1,
				limit: 10,
				total: 1
			},
			logList: [],
			showModal: false
		}
	},
  mounted() {
		this.init()
		this.initAddress()
		
		this.initLog()
  },
	activated() {
		// Check if address list needs to be refreshed
		if (sessionStorage.getItem('withdrawInit')) {
			sessionStorage.removeItem('withdrawInit')
			this.initAddress()
		}
	},
	computed: {
		// 过滤已绑定的地址 - 直接从API数据中过滤
		filteredWithdrawList() {
			const bindedProtocols = this.addressArr.map(item => item.Protocol)
			console.log('Binded protocols from API:', bindedProtocols)
			
			const filtered = this.withdrawAddressList.filter(item => {
				const isBindedInAPI = bindedProtocols.includes(item.key)
				console.log(`Checking ${item.key}: is binded in API = ${isBindedInAPI}`)
				
				if (isBindedInAPI) {
					// 从API数据中找到对应的地址信息
					const apiData = this.addressArr.find(addr => addr.Protocol === item.key)
					if (apiData) {
						// 确保界面显示的数据是最新的
						item.address = apiData.Address
						item.ID = apiData.ID
					}
				}
				
				return isBindedInAPI
			})
			
			console.log('Filtered withdraw list:', filtered)
			return filtered
		},
		// 判断是否有已绑定的地址 - 直接检查API数据
		hasBindedAddress() {
			const hasAddress = this.addressArr && this.addressArr.length > 0
			console.log('Address array from API:', this.addressArr)
			console.log('Has binded address:', hasAddress)
			return hasAddress
		}
	},
	methods: {
		init() {
			// 初始化时不获取余额，等用户选择币种后再获取
			// 如果已经选择了币种，则获取对应余额
			if (this.withdrawInfo.key) {
				this.updateBalance()
			}
		},
		// 根据选择的币种获取对应余额
		updateBalance() {
			if (!this.withdrawInfo.key) {
				this.userMoney = 0
				return
			}

			// 将提现地址的key转换为币种简称
			const shortName = this.getShortNameFromKey(this.withdrawInfo.key)
			if (!shortName) {
				this.userMoney = 0
				return
			}

			let form = new FormData()
			form.append('ShortName', shortName)
			form.append('current', 1)
			form.append('pageSize', 10)
			wallet(form).then(res => {
				let data = res.data.Items[0]
				if (data) {
					this.userMoney = formatNumber(data.CapitalUse)
				} else {
					this.userMoney = 0
				}
			}).catch(err => {
				console.error('获取余额失败:', err)
				this.userMoney = 0
			})
		},
		// 将提现地址的key转换为币种简称
		getShortNameFromKey(key) {
			// 币种映射表：提现地址key -> 币种简称
			const keyToShortName = {
				'BTC': 'btc',
				'ETH-ERC20': 'eth',
				'USDT-TRC20': 'usdt',
				'USDT-ERC20': 'usdt',
				'USDC-TRC20': 'usdc',
				'USDC-ERC20': 'usdc'
			}
			return keyToShortName[key] || null
		},
		initAddress() {
      addressList({
        current: 1,
        pageSize: 30
      }).then(res => {
        this.addressArr = res.data.Items || []
				console.log('Address data from API:', this.addressArr) // 调试信息
				
				// 更新addressForm用于地址绑定模态框
				this.addressArr.forEach(v => {
					this.addressForm[v.Protocol] = v.Address
				})
      })
    },
		changePage(page) {
      this.page.page = page
      this.initLog()
    },
			initLog() {
		let form = new FormData()
		form.append('current', this.page.page)
    form.append('limit', this.page.limit)
    withdrawLists(form).then(res => {
			this.logList = res.data.Items
			this.page.total = res.data.Pagination.totalRecords
		})
	},
		back() {
			this.$router.go(-1)
		},
		submit() {
			if (!this.form.money) {
				this.$toast.fail(this.$t('withdraw.labelPlaceholder4'))
				return
			}
			if (!this.withdrawInfo.ID) {
				this.$toast.fail(this.$t('withdraw.labelPlaceholder2'))
				return
			}
			// 获取当前选择币种的简称
			const shortName = this.getShortNameFromKey(this.withdrawInfo.key)
			if (!shortName) {
				this.$toast.fail('请选择有效的提币币种')
				return
			}

			let form = new FormData()
			form.append('Id', this.withdrawInfo.ID)
			form.append('Price', this.form.money)
			form.append('Type', shortName) // 使用动态币种而不是固定的 'usdt'
			withdraw(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.$t('withdraw.success'))
					this.updateBalance() // 提现成功后更新余额
					this.page.page = 1
					this.initLog()
					this.form.money = ''
				} else {
				  this.$toast.fail(res.msg)
				}
			})
		},
		setAll() {
			this.form.money = this.userMoney
		},
		cancel() {
			this.showModal = false
      this.$store.state.showModalBg = false
		},
		chooseBit(data) {
			// 从API数据中找到对应的地址信息
			const apiData = this.addressArr.find(addr => addr.Protocol === data.key)

			if (apiData) {
				this.withdrawInfo = {
					key: data.key,
					address: apiData.Address,
					ID: apiData.ID
				}
			} else {
				this.withdrawInfo = {
					key: data.key,
					address: '',
					ID: ''
				}
			}

			console.log('Selected withdraw info:', this.withdrawInfo) // 调试信息

			// 选择币种后立即更新余额
			this.updateBalance()
		},
		toBind() {
			this.$router.push({
				name: 'address',
				query: {
					from: 'withdraw'
				}
			})
		},
		submitAddress() {
			this.cancel()
		}
	}
}
</script>
<style lang="scss" scoped>
/* Withdraw page style optimization */
.recharge-page {
  .recharge-main {
    .title {
      font-size: 18px;
      font-weight: 600;
      color: var(--text-color, #333);
      margin-bottom: 8px;
    }
    
    .sub-title {
      font-size: 14px;
      color: var(--text-light, #999);
      margin-bottom: 20px;
    }
    
    /* 没有绑定地址时的提示样式 */
    .no-address-tip {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 40px 20px;
      
      .tip-content {
        text-align: center;
        color: var(--text-light, #999);
        
        img {
          width: 64px;
          height: 64px;
          opacity: 0.6;
          margin-bottom: 16px;
        }
        
        p {
          font-size: 16px;
          margin-bottom: 20px;
          color: var(--text-color, #666);
        }
        
        .tip-btn {
          display: inline-block;
          background: var(--primary-color, #1989fa);
          color: white;
          padding: 12px 24px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.3s ease;
          
          &:hover {
            background: var(--primary-dark, #1976d2);
            transform: translateY(-1px);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
      }
    }
    
    .recharge-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 15px;
      margin-bottom: 20px;
      
      .list {
        background: var(--bg-white, #fff);
        border-radius: 12px;
        padding: 16px;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 2px solid transparent;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        
        &:hover {
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        
        &.active {
          border-color: var(--primary-color, #1989fa);
          background: linear-gradient(135deg, rgba(25, 137, 250, 0.05) 0%, rgba(25, 137, 250, 0.02) 100%);
          box-shadow: 0 4px 16px rgba(25, 137, 250, 0.2);
        }
        
        &.big {
          grid-column: span 1;
        }
        
        .name {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          gap: 8px;
          
          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
          }
          
          span {
            font-size: 14px;
            font-weight: 500;
            color: var(--text-color, #333);
            text-align: center;
          }
        }
      }
    }
  }
  
  /* Withdraw status styles */
  .list-table {
    .point {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 6px;
      
      &.red {
        background-color: #ff3b30;
      }
      
      &.yellow {
        background-color: #ff9f43;
      }

      &.green {
        background-color: #4cd964;
      }
    }
  }
}

/* Responsive design */
@media screen and (max-width: 768px) {
  .recharge-page {
    .recharge-main {
      .no-address-tip {
        padding: 30px 15px;
        
        .tip-content {
          img {
            width: 56px;
            height: 56px;
          }
          
          p {
            font-size: 15px;
          }
          
          .tip-btn {
            padding: 10px 20px;
            font-size: 13px;
          }
        }
      }
      
      .recharge-list {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        
        .list {
          padding: 12px;
          
          .name {
            img {
              width: 28px;
              height: 28px;
            }
            
            span {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .recharge-page {
    .recharge-main {
      .no-address-tip {
        padding: 25px 10px;
        
        .tip-content {
          img {
            width: 48px;
            height: 48px;
          }
          
          p {
            font-size: 14px;
            margin-bottom: 16px;
          }
          
          .tip-btn {
            padding: 8px 16px;
            font-size: 12px;
          }
        }
      }
      
      .recharge-list {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
        
        .list {
          padding: 10px;
          
          .name {
            gap: 6px;
            
            img {
              width: 24px;
              height: 24px;
            }
            
            span {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
